export enum backUseOrGiveType{
    /** 打开某个预制体  如果打开之后需要有什么事件则需要在对应的预制体中实现对应的方法 */
    openOnePrefab,
    /** 加钱 */
    addCoin,
    /** 触发事件 */
    openEvent,
    /** 触发聊天 */
    chatLink,
    /**分解典当铺物品 */
    resolvePawnShopObj,
    /**出售 */
    sell,
    /** 打开新的界面 */
    openNewLayer,
    /**解锁套牛称号 */
    lieYing,
    /**升官 */
    upgradeOfficer,
}

/**
 * 背包物品使用规则接口
 */
export interface backpackUseRuleI{
    /** 物品id */
    backId:number,
    /** 是否是唯一的 如果是唯一的则整局游戏只能触发一次 */
    isOnly:boolean,
    /** 使用类型 */
    backUseOrGiveType:backUseOrGiveType,
    /** 使用参数 */
    backUseOrGiveParam:{},
}

export interface backpackGiveRuleI extends backpackUseRuleI{
    //给定的npc
    npcName:string
}

export interface backpackGiveRuleMap{
    [id:string]:backpackGiveRuleI[];
}

export interface backpackUseRuleMap{
    [id:string]:backpackUseRuleI;
}

export interface backpackSaveData{
    //使用物品  对应的是使用次数
    useObjs:{[id:number]:number},
    //赠送物品  对应的参数分别是  物品id npc名字 给的次数
    giveObjs:{[id:number]:{backId:number,npcName:string,giveCount:number}[]};
}

export let backpackUpdataDialog:string = "backpackPrefab.onShowGoods";

export enum backpackOpenType{
    normal,
    select,
    stall,
    selectCount,
}